angular.module('picmonicng').factory('Playlists', [
  '$resource',
  function ($resource) {
    return $resource(
      '/api/v2/playlists/:playlist_id/:resource/:resource_id',
      {
        playlist_id: '@playlist_id',
        resource: '@resource',
        resource_id: '@id',
      },
      {
        getv3: {
          method: 'GET',
          url: '/api/v3/playlists/:playlist_id/:resource/:resource_id',
        },
        query: {
          method: 'GET',
          url: '/api/v3/playlists/:playlist_id/:resource/:resource_id',
          isArray: true,
        },
        savev3: {
          method: 'POST',
          url: '/api/v3/playlists/:playlist_id/:resource/:resource_id',
        },
        update: { method: 'PUT', isArray: false },
        find: {
          method: 'GET',
          url: '/api/v3/playlists/:playlist_id',
          isArray: false,
        },
        queryv2: { method: 'GET', isArray: true },
      }
    );
  },
]);
